import React from 'react';
import { MSALHandler } from './msal-handler';

const MSAuthenticate = () => {
  return (
    <>
      <div className="ms-authenticate-indicator">Logging In...</div>
      <MSALHandler />
    </>
  );
};

export default MSAuthenticate;
